import useTenancies from './use-tenancies';

export default useTenancies;